import { NumberDecimalFormat } from '@components/shared/Format'
import { Store } from '@stores/Store'

export class SummaryCalculation {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Summary Total Income

  get totalCorePlanIncomeMonthlyAmount() {
    const { store } = this
    const { retailMarginAmount, performanceBonus, leadershipBonus, fosterBonus, rubyBonus } = store
    const { depthBonus } = store.depthCalculation

    return NumberDecimalFormat(retailMarginAmount + performanceBonus + leadershipBonus + fosterBonus + rubyBonus + depthBonus)
  }

  get totalCorePlanIncomeAnnualAmount() {
    return this.totalCorePlanIncomeMonthlyAmount * 12
  }

  get totalCorePlusMonthlyAmount() {
    const { store } = this
    const { bronzeFoundationMonthlyBonusAmount, bronzeBuilderMonthlyBonusAmount } = store.bronzeIncentiveCalculation
    const { performancePlusMonthlyAmount } = store.performancePlusCalculation

    return bronzeFoundationMonthlyBonusAmount + bronzeBuilderMonthlyBonusAmount + performancePlusMonthlyAmount
  }

  get totalCorePlusAnnualAmount() {
    const { store } = this
    const { bronzeFoundationAnnualBonusAmount, bronzeBuilderAnnualBonusAmount } = store.bronzeIncentiveCalculation
    const { bronzeBuilderConsitencyIncentiveAmount } = store.bronzeConsistencyIncentiveCalculation
    const { performancePlusAnnualAmount } = store.performancePlusCalculation
    const { leadershipPlusIncentive } = store.leadershipPlusIncentiveCalculation
    const { twoTimeCashIncentiveAmount } = store.twoTimeCashIncentiveCalculation

    return bronzeFoundationAnnualBonusAmount + bronzeBuilderAnnualBonusAmount +
      bronzeBuilderConsitencyIncentiveAmount + performancePlusAnnualAmount +
      leadershipPlusIncentive + twoTimeCashIncentiveAmount
  }

  get totalIncomeMonthlyAmount() {
    const { totalCorePlanIncomeMonthlyAmount, totalCorePlusMonthlyAmount } = this
    return totalCorePlanIncomeMonthlyAmount + totalCorePlusMonthlyAmount
  }

  get totalIncomeAnnualAmount() {
    const { totalCorePlanIncomeAnnualAmount, totalCorePlusAnnualAmount } = this
    return totalCorePlanIncomeAnnualAmount + totalCorePlusAnnualAmount
  }

}
